export const modalConfig = {
    content: {
        width: "400px",
        padding: "20px 24px 16px",
        alignItems: "center",
        flexDirection: "column" as any,
        display: "flex",
    },
};

export const TOOLTIP_WIDTH = "175px";
